import { loadable } from '../shared/utils/loadable';
//import loadable from '@loadable/component'
import AdminLayout from '../layouts/AdminLayout';
const authRouters = [
    {
        path: '/*',
        component: loadable(() => import('../layouts/NewLayout')),
    },
    {
        path: '/admin/*',
        component: AdminLayout,
    },
    {
        path: '/newlayout/*',
        component: loadable(() => import('../layouts/NewLayout')),
    },
    


]
export { authRouters };